import type { HealthTier } from '../../types';

// Health tiers (PEL-2852). Dormant is slate rather than red: "nobody showed up" is a
// different problem from "people showed up and it's going badly", and colouring it like
// the worst score would bury the distinction.
export const HEALTH_TIER_STYLES: Record<HealthTier, { label: string; color: string; bg: string }> = {
  healthy: { label: 'Healthy', color: '#22c55e', bg: 'rgba(34, 197, 94, 0.15)' },
  watch: { label: 'Watch', color: '#f59e0b', bg: 'rgba(245, 158, 11, 0.15)' },
  at_risk: { label: 'At risk', color: '#ef4444', bg: 'rgba(239, 68, 68, 0.15)' },
  dormant: { label: 'Dormant', color: '#94a3b8', bg: 'rgba(148, 163, 184, 0.15)' },
};
